import React from 'react';
import { Table, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { links } from '../data/links';

const LinkList = () => (
    <div className="container py-5">
        <h2>📋 Промо-ссылки</h2>
        <Table striped responsive>
            <thead>
            <tr>
                <th>Название</th>
                <th>Дата создания</th>
                <th>Переходы</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            {links.map(link => (
                <tr key={link.id}>
                    <td>{link.name}</td>
                    <td>{link.created_at}</td>
                    <td>{link.total_clicks}</td>
                    <td>
                        <Link to={`/stats/${link.id}`}>
                            <Button color="primary" size="sm">Подробнее</Button>
                        </Link>
                    </td>
                </tr>
            ))}
            </tbody>
        </Table>
    </div>
);

export default LinkList;
